import Period from './period';

const Periods = ({ activePeriod, periods }) => (
  periods.map((period, index) => (
    <Period period={period} active={activePeriod === index} />
  ))
);

export default Periods;
